import { Link } from 'react-router-dom';

export default function Header({ tokenDetails, onSignOut, isUnlockAdministrator = false }) {
    const signedInName = tokenDetails.name || tokenDetails.preferred_username || null;
    const signedInEmail = tokenDetails.email || null;

    return (
        <header className="jcwa-site-header">
            <div className="jcwa-banner-bar">
                <div className="jcwa-banner-content">
                    <img
                        className="jcwa-banner-flag"
                        src="/us-flag.png"
                        alt="United States flag icon"
                    />
                    <span>An official website of the United States government</span>
                </div>
            </div>

            <div className="jcwa-main-header">
                <div className="jcwa-header-inner">
                    <div className="jcwa-logo">
                        <a href="https://jcwa.cybercom.mil/" target="_blank" rel="noreferrer">
                            <img
                                src="/USCC_Logo.png"
                                alt="JCWA"
                            />
                        </a>
                        <Link to="/" className="unlock-logo" aria-label="Unlock home">
                            <img
                                src="/unlock.png"
                                alt="Unlock"
                            />
                        </Link>
                    </div>
                    {signedInName && onSignOut ? (
                        <div className="jcwa-user-meta">
                            {isUnlockAdministrator ? (
                                <Link to="/admin" className="jcwa-user-meta__admin-link">
                                    <img
                                        className="jcwa-user-meta__admin-icon"
                                        src="/icons/settings.png"
                                        alt=""
                                        aria-hidden="true"
                                    />
                                    <span>Admin</span>
                                </Link>
                            ) : null}
                            <span className="jcwa-user-meta__name">
                                Signed in as: {signedInName}
                            </span>
                            {signedInEmail ? (
                                <span className="jcwa-user-meta__email">{signedInEmail}</span>
                            ) : null}
                            <button
                                type="button"
                                className="jcwa-user-meta__action"
                                onClick={onSignOut}
                            >
                                Sign out
                            </button>
                        </div>
                    ) : null}
                </div>
            </div>
        </header>
    );
}
